export const INVENTORY = [
  {
    category: "Bedroom",
    items: [
      {
        id: "bed",
        name: "Bed",
        types: [
          { id: "bed-baby-wooden", label: "Baby Wooden Bed" },
          { id: "bed-bunk-dismantlable", label: "Bunk Bed - Dismantlable" },
          { id: "bed-cradle-dismantlable", label: "Cradle - Dismantlable" },
          { id: "bed-diwan-cum", label: "Diwan Cum Bed" },
          { id: "bed-double-dismantlable", label: "Double Bed - Dismantlable" },
          { id: "bed-king-storage", label: "King Size Bed - With Storage" },
          { id: "bed-king-no-storage", label: "King Size Bed - Without Storage" },
          { id: "bed-queen-storage", label: "Queen Size Bed - With Storage" },
          { id: "bed-queen-no-storage", label: "Queen Size Bed - Without Storage" },
          { id: "bed-single-foldable", label: "Single Bed - Foldable" },
          { id: "bed-single-storage", label: "Single Bed - With Storage" },
          { id: "bed-single-no-storage", label: "Single Bed - Without Storage" },
          { id: "bed-single-non-storage-dismantlable", label: "Single Bed Non Storage - Dismantlable" },
          { id: "bed-single-storage-dismantlable", label: "Single Bed Storage - Dismantlable" }
        ]
      },

      {
        id: "mattress",
        name: "Mattress",
        types: [
          { id: "mattress-double-foldable", label: "Double Bed Mattress - Foldable" },
          { id: "mattress-double-non-foldable", label: "Double Bed Mattress - Non Foldable" },
          { id: "mattress-single-foldable", label: "Single Bed Mattress - Foldable" },
          { id: "mattress-single-non-foldable", label: "Single Bed Mattress - Non Foldable" }
        ]
      },

      {
        id: "table",
        name: "Table",
        types: [
          { id: "table-bedside", label: "Bed Side Table" },
          { id: "table-center", label: "Center Table" },
          { id: "table-study", label: "Study / Computer Table" }
        ]
      },

      {
        id: "chair",
        name: "Chair",
        types: [
          { id: "chair-arm", label: "Arm Chair" },
          { id: "chair-beanbag", label: "Bean Bag / Pouffe" },
          { id: "chair-office", label: "Office Chair" }
        ]
      },

      {
        id: "television",
        name: "Television",
        types: [
          { id: "tv-52-65", label: "LCD/LED 52\" - 65\"" },
          { id: "tv-65-above", label: "LCD/LED 65\" & Above" },
          { id: "tv-40-below", label: "LCD/LED TV 40\" & Below" },
          { id: "tv-42-50", label: "LCD/LED TV 42\" - 50\"" },
          { id: "tv-52-above", label: "LCD/LED TV 52\" & Above" },
          { id: "tv-regular-old", label: "Regular TV (Old Model)" }
        ]
      },

      {
        id: "ac",
        name: "Air Conditioner",
        types: [
          { id: "ac-split", label: "Split Air Conditioner (AC)" },
          { id: "ac-window", label: "Window Air Conditioner (AC)" }
        ]
      },

      {
        id: "appliances",
        name: "Appliances",
        types: [
          { id: "air-cooler", label: "Air Cooler" },
          { id: "air-purifier", label: "Air Purifier" },
          { id: "fan", label: "Ceiling/Table Fan" },
          { id: "garment-steamer", label: "Garment Steamer" },
          { id: "instant-geyser", label: "Instant Geyser" }
        ]
      },

      {
        id: "wardrobe",
        name: "Wardrobe / Almirah",
        types: [
          { id: "wardrobe-double", label: "Double Door Wardrobe" },
          { id: "wardrobe-five", label: "Five Door Wardrobe" },
          { id: "wardrobe-four", label: "Four Door Wardrobe" },
          { id: "wardrobe-single", label: "Single Door Wardrobe" },
          { id: "wardrobe-sliding", label: "Sliding Door Wardrobe" },
          { id: "almirah-steel-large", label: "Steel Almirah Large" },
          { id: "almirah-steel-medium", label: "Steel Almirah Medium" },
          { id: "wardrobe-triple", label: "Triple Door Wardrobe" }
        ]
      },

      {
        id: "storage",
        name: "Cabinet & Storage",
        types: [
          { id: "bookshelf-large", label: "Book Shelf Large" },
          { id: "bookshelf-medium", label: "Book Shelf Medium" },
          { id: "bookshelf-small", label: "Book Shelf Small" },
          { id: "chest-drawers-large", label: "Chest of Drawers Large" },
          { id: "chest-drawers-medium", label: "Chest of Drawers Medium" },
          { id: "chest-drawers-small", label: "Chest of Drawers Small" },
          { id: "display-cabinet-large", label: "Display Cabinet Large" },
          { id: "display-cabinet-small", label: "Display Cabinet Small" },
          { id: "dressing-table", label: "Dressing Table" },
          { id: "entertainment-unit", label: "Entertainment/TV Unit" },
          { id: "iron-locker-small", label: "Iron Locker Small" },
          { id: "plastic-cupboard", label: "Plastic Cupboard" },
          { id: "safe-small", label: "Safe Small" },
          { id: "trunk", label: "Trunk" },
          { id: "tv-table", label: "TV Table" },
          { id: "wall-shelf", label: "Wall Shelf" }
        ]
      }
    ]
  },
  {
    category: "Living Room",
    items: [
      {
        id: "sofa",
        name: "Sofa",
        types: [
          { id: "sofa-1-seater", label: "1 Seater Sofa" },
          { id: "sofa-1-seater-leather", label: "1 Seater Sofa - Leather" },
          { id: "sofa-2-seater", label: "2 Seater Sofa" },
          { id: "sofa-2-seater-leather", label: "2 Seater Sofa - Leather" },
          { id: "sofa-3-seater", label: "3 Seater Sofa" },
          { id: "sofa-3-seater-lshape", label: "3 Seater Sofa - L Shape" },
          { id: "sofa-3-seater-leather", label: "3 Seater Sofa - Leather" },
          { id: "sofa-4-seater", label: "4 Seater Sofa" },
          { id: "sofa-5-seater-lshape", label: "5 Seater Sofa - L Shape" },
          { id: "sofa-7-seater-lshape", label: "7 Seater Sofa - L Shape" },
          { id: "sofa-recliner-1", label: "Recliner Sofa 1-Seater" },
          { id: "sofa-recliner-2", label: "Recliner Sofa 2-Seater" },
          { id: "sofa-recliner-3", label: "Recliner Sofa 3-Seater" },
          { id: "sofa-cum-bed", label: "Sofa Cum Bed" }
        ]
      },

      {
        id: "dining",
        name: "Dining Tables & Chairs",
        types: [
          { id: "dining-table-4", label: "Dining Table Only - 4 Seater" },
          { id: "dining-table-6", label: "Dining Table Only - 6 Seater" },
          { id: "dining-table-8", label: "Dining Table Only - 8 Seater" },
          { id: "glass-dining-4", label: "Glass Top Dining Table Only - 4 Seater" },
          { id: "glass-dining-6", label: "Glass Top Dining Table Only - 6 Seater" },
          { id: "glass-dining-8", label: "Glass Top Dining Table Only - 8 Seater" },
          { id: "marble-dining-4", label: "Marble Top Dining Table Only - 4 Seater" },
          { id: "marble-dining-6", label: "Marble Top Dining Table Only - 6 Seater" },
          { id: "marble-dining-8", label: "Marble Top Dining Table Only - 8 Seater" }
        ]
      },

      {
        id: "television",
        name: "Television",
        types: [
          { id: "tv-52-65", label: "LCD/LED 52\" - 65\"" },
          { id: "tv-65-above", label: "LCD/LED 65\" & Above" },
          { id: "tv-40-below", label: "LCD/LED TV 40\" & Below" },
          { id: "tv-42-50", label: "LCD/LED TV 42\" - 50\"" },
          { id: "tv-52-above", label: "LCD/LED TV 52\" & Above" },
          { id: "tv-old", label: "Regular TV (Old Model)" }
        ]
      },

      {
        id: "table",
        name: "Tables",
        types: [
          { id: "table-coffee-large", label: "Coffee Table Large" },
          { id: "table-coffee-small", label: "Coffee Table Small" },
          { id: "table-console", label: "Console Table" },
          { id: "table-folding", label: "Folding Table" }
        ]
      },

      {
        id: "chair",
        name: "Chairs & Seating",
        types: [
          { id: "chair-arm", label: "Arm Chair" },
          { id: "chair-beanbag", label: "Bean Bag/Pouffe" },
          { id: "chair-bench", label: "Bench" },
          { id: "chair-folding", label: "Folding Chair" },
          { id: "chair-high", label: "High Chair" },
          { id: "chair-plastic", label: "Plastic Chair" },
          { id: "chair-rocking", label: "Rocking Chair" },
          { id: "chair-settee", label: "Settee" },
          { id: "chair-stool", label: "Stool" },
          { id: "chair-study", label: "Study Chair" },
          { id: "chair-wooden", label: "Wooden Chair" }
        ]
      },

      {
        id: "ac",
        name: "Air Conditioner",
        types: [
          { id: "ac-split", label: "Split Air Conditioner (AC)" },
          { id: "ac-window", label: "Window Air Conditioner (AC)" }
        ]
      },

      {
        id: "storage",
        name: "Cabinets & Storage",
        types: [
          { id: "bookshelf-large", label: "Book Shelf Large" },
          { id: "bookshelf-medium", label: "Book Shelf Medium" },
          { id: "bookshelf-small", label: "Book Shelf Small" },
          { id: "drawers-large", label: "Chest of Drawers Large" },
          { id: "drawers-medium", label: "Chest of Drawers Medium" },
          { id: "drawers-small", label: "Chest of Drawers Small" },
          { id: "cabinet-display-large", label: "Display Cabinet Large" },
          { id: "cabinet-display-small", label: "Display Cabinet Small" },
          { id: "entertainment-unit", label: "Entertainment/TV Unit" },
          { id: "plastic-cupboard", label: "Plastic Cupboard" },
          { id: "prayer-unit", label: "Prayer Unit/Mandir" },
          { id: "shoe-rack-metal", label: "Shoe Rack Metal" },
          { id: "shoe-rack-wooden", label: "Shoe Rack Wooden" },
          { id: "tv-table", label: "TV Table" },
          { id: "wall-shelf", label: "Wall Shelf" }
        ]
      },

      {
        id: "appliances",
        name: "Appliances",
        types: [
          { id: "air-cooler", label: "Air Cooler" },
          { id: "air-purifier", label: "Air Purifier" },
          { id: "fan", label: "Ceiling/Table Fan" },
          { id: "music-video-system", label: "Music/Video System" }
        ]
      },

      {
        id: "bar-furniture",
        name: "Bar Furniture",
        types: [
          { id: "bar-cabinet", label: "Bar Cabinet" },
          { id: "bar-cabinet-large", label: "Bar Cabinet Large" },
          { id: "bar-chair-stool", label: "Bar Chair / Stool" },
          { id: "bar-trolley", label: "Bar Trolley" },
          { id: "bar-unit", label: "Bar Unit" }
        ]
      }
    ]
  },
  {
    category: "Kitchen",
    items: [
      {
        id: "refrigerator",
        name: "Refrigerator",
        types: [
          { id: "fridge-300-399", label: "Fridge 300–399 Lts" },
          { id: "fridge-400-499", label: "Fridge 400–499 Lts" },
          { id: "fridge-500-above", label: "Fridge Above 500 Lts" },
          { id: "fridge-single-door", label: "Fridge Single Door" },
          { id: "fridge-upto-299", label: "Fridge Upto 299 Lts" }
        ]
      },

      {
        id: "kitchen-items",
        name: "Kitchen Items",
        types: [
          { id: "gas-stove-hob", label: "Gas Stove / Hob" },
          { id: "kitchen-metal-rack", label: "Kitchen Metal Rack" },
          { id: "lpg-cylinder", label: "LPG Gas Cylinder" },
          { id: "water-drum", label: "Water Drum" }
        ]
      },

      {
        id: "kitchen-appliances",
        name: "Appliances",
        types: [
          { id: "air-fryer", label: "Air Fryer" },
          { id: "bbq-grill-large", label: "Barbeque Grill Large" },
          { id: "bbq-grill-small", label: "Barbeque Grill Small" },
          { id: "cooking-range", label: "Cooking Range" },
          { id: "dishwasher", label: "Dish Washer" },
          { id: "atta-chakki", label: "Domestic Flour Mill / Atta Chakki" },
          { id: "electric-tandoor", label: "Electric Tandoor" },
          { id: "food-processor", label: "Food Processor" },
          { id: "pressure-cooker-stand", label: "Holds 2-3 Pressure Cookers (5 Litre) Or Equivalent" },
          { id: "hood-chimney", label: "Hood Chimney" },
          { id: "microwave-otg", label: "Microwave Oven & OTG" },
          { id: "mixer-grinder", label: "Mixer Grinder" },
          { id: "water-purifier", label: "Water Purifier" },
          { id: "wet-grinder", label: "Wet Grinder" }
        ]
      },

      {
        id: "kitchen-furniture",
        name: "Furniture",
        types: [
          { id: "kitchen-rack", label: "Kitchen Rack" },
          { id: "serving-trolley", label: "Serving Trolley" },
          { id: "side-table", label: "Side Table" }
        ]
      }
    ]
  },
  {
    category: "Miscellaneous",
    items: [
      {
        id: "washing-machine",
        name: "Washing Machine",
        types: [
          { id: "wm-6-9-below", label: "Washing Machine <6.9kg" },
          { id: "wm-7-7-9", label: "Washing Machine 7–7.9kg" },
          { id: "wm-8-plus", label: "Washing Machine 8kg+" }
        ]
      },

      {
        id: "decor",
        name: "Decorative Items",
        types: [
          { id: "aquarium-large", label: "Aquarium Large" },
          { id: "carpet-rolled", label: "Carpet Rolled" },
          { id: "fountain-large", label: "Indoor Fountain Large" },
          { id: "fountain-small", label: "Indoor Fountain Small" },
          { id: "mirror", label: "Mirror" },
          { id: "painting-large", label: "Painting / Photo Large" },
          { id: "painting-medium", label: "Painting / Photo Medium" },
          { id: "pooja-lamp", label: "Pooja Lamp" },
          { id: "statue-large", label: "Statue Large" },
          { id: "statue-medium", label: "Statue Medium" },
          { id: "statue-small", label: "Statue Small" },
          { id: "vase-large", label: "Vase Large" },
          { id: "vase-small", label: "Vase Small" },
          { id: "wall-frames-large", label: "Wall Frames Large" },
          { id: "wall-frames-medium", label: "Wall Frames Medium" }
        ]
      },

      {
        id: "suitcases",
        name: "Suitcases & Trolleys",
        types: [
          { id: "suitcase-large", label: "Suitcase Large (25kg)" },
          { id: "suitcase-medium", label: "Suitcase Medium (15kg)" },
          { id: "suitcase-small", label: "Suitcase Small (7kg)" }
        ]
      },

      {
        id: "bicycle",
        name: "Bicycle",
        types: [
          { id: "bicycle-adult", label: "Bicycle Adult" },
          { id: "bicycle-kids", label: "Bicycle Kids" }
        ]
      },

      {
        id: "home-utility",
        name: "Home Utility",
        types: [
          { id: "clothes-stand", label: "Clothes Stand" },
          { id: "clothes-dryer-foldable", label: "Foldable Clothes Dryer" },
          { id: "inverter-battery", label: "Inverter - With Battery" },
          { id: "sewing-machine", label: "Sewing Machine" },
          { id: "step-ladder", label: "Step Ladder" },
          { id: "laundry-basket", label: "Storage / Laundry Basket" }
        ]
      },

      {
        id: "musical-instruments",
        name: "Musical Instruments",
        types: [
          { id: "drum-set", label: "Drum Set - 5 Piece" },
          { id: "keyboard", label: "Electronic Keyboard" },
          { id: "grand-piano", label: "Grand Piano" },
          { id: "guitar", label: "Guitar" },
          { id: "harmonium", label: "Harmonium" },
          { id: "piano", label: "Piano" },
          { id: "synthesizer", label: "Synthesizer" },
          { id: "tabla", label: "Tabla" }
        ]
      },

      {
        id: "kids-vehicle",
        name: "Kids Vehicle",
        types: [
          { id: "kids-4-wheeler", label: "Kids Four Wheeler" },
          { id: "kids-3-wheeler", label: "Kids Three Wheeler" }
        ]
      },

      {
        id: "gym-equipment",
        name: "Gym Equipments",
        types: [
          { id: "exercise-cycle", label: "Exercise Cycle" },
          { id: "treadmill-foldable", label: "Tread Mill Foldable" }
        ]
      },

      {
        id: "swing",
        name: "Swing",
        types: [
          { id: "baby-swing-large", label: "Baby Swing Large" },
          { id: "baby-swing-small", label: "Baby Swing Small" },
          { id: "swing", label: "Swing" }
        ]
      },

      {
        id: "home-appliances",
        name: "Home Appliances",
        types: [
          { id: "computer-system", label: "Computer System" },
          { id: "printer", label: "Printer" },
          { id: "speaker", label: "Speaker" }
        ]
      },

      {
        id: "plants",
        name: "Plants & Pots",
        types: [
          { id: "pots-big", label: "Big Pots" },
          { id: "pots-small", label: "Small Pots" }
        ]
      },

      {
        id: "self-carton",
        name: "Self Carton",
        types: [
          { id: "carton-large", label: "Large" },
          { id: "carton-medium", label: "Medium" },
          { id: "carton-small", label: "Small" },
          { id: "gunny-bag", label: "Gunny Bag" },
          { id: "carton", label: "Carton (1.5ft x 1.5ft x 2ft)" }
        ]
      }
    ]
  },
  {
    category: "Vehicle",
    items: [
      {
        id: "car",
        name: "Car",
        types: [
          { id: "car", label: "Car" }
        ]
      },
      {
        id: "bike",
        name: "Bike",
        types: [
          { id: "bike", label: "Bike" }
        ]
      }
    ]
  }
]
